import { createContext, useContext, useEffect, useState } from "react";

const BannerContext = createContext();

export const BannerProvider = ({ children }) => {
  const [banners, setBanners] = useState(() => {
    const stored = localStorage.getItem("banners");
    return stored ? JSON.parse(stored) : [];
  });

  useEffect(() => {
    localStorage.setItem("banners", JSON.stringify(banners));
  }, [banners]);

  const addBanner = (banner) => {
    setBanners(prev => [...prev, banner]);
  };

  const updateBanner = (updatedBanner) => {
    setBanners(prev =>
      prev.map(b => (b.id === updatedBanner.id ? updatedBanner : b))
    );
  };

  const deleteBanner = (id) => {
    setBanners(prev => prev.filter(b => b.id !== id));
  };

  // Only banners with status: true will be used in UI
  const activeBanners = banners.filter(b => b.status);

  return (
    <BannerContext.Provider value={{ banners, activeBanners, addBanner, updateBanner, deleteBanner }}>
      {children}
    </BannerContext.Provider>
  );
};

export const useBanner = () => useContext(BannerContext);